<template>
  <div id="taskbar">
    <div class="background"></div>
    <div class="items">
      <TaskBarItem
        :icon-src="require('../assets/task-bar-icons/icon-drone.svg')"
        window-name="drone"
        v-if="jobAccepted"
      />
      <TaskBarItem
        :icon-src="require('../assets/task-bar-icons/icon-news.svg')"
        window-name="news"
      />
      <TaskBarItem
        :icon-src="require('../assets/task-bar-icons/icon-email.svg')"
        window-name="email"
      />
      <TaskBarItem
        :icon-src="require('../assets/task-bar-icons/icon-social.svg')"
        window-name="social"
      />
    </div>
  </div>
</template>

<script>
import TaskBarItem from "./TaskBarItem";
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "TaskBar",
  components: { TaskBarItem },
  computed: {
    jobAccepted() {
      return gameStateStore.jobAccepted;
    },
  },
};
</script>

<style scoped lang="scss">
#taskbar {
  .background {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    height: 30px;

    background-color: rgba(102, 102, 102, 0.336);

    z-index: 20;
  }

  .items {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;

    margin-bottom: 10px;

    z-index: 25;
  }
}
</style>
